module.exports = __webpack_public_path__ + "img/rys-down-close.1c309b12.png";